import { render, staticRenderFns } from "./TableOfContents.vue?vue&type=template&id=b22b007e&scoped=true&"
import script from "./TableOfContents.vue?vue&type=script&lang=js&"
export * from "./TableOfContents.vue?vue&type=script&lang=js&"
import style0 from "./TableOfContents.vue?vue&type=style&index=0&id=b22b007e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b22b007e",
  null
  
)

export default component.exports